import { render, staticRenderFns } from "./AccrualHistory.vue?vue&type=template&id=6a9a5707&"
import script from "./AccrualHistory.vue?vue&type=script&lang=js&"
export * from "./AccrualHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports